<template>
  <div class="dischargeCapacity">
    <title1 type="1" title="工单响应时效" />
    <div style="width: 440px; height: 280px">
      <MyEcharts
        v-if="showcdata"
        :id="'smart3_6'"
        :options="cdata"
      />
    </div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title4";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    return {
      showcdata: false,
      // title:"月度充/放电量"
      cdata: {
        // tooltip: {
        //   trigger: "axis",
        //   show: true,
        //   axisPointer: {
        //     type: "cross",
        //     label: {
        //       backgroundColor: "#6a7985",
        //     },
        //   },
        //   // textStyle: {
        //   //   fontSize: 50  // 设置字体大小为16px
        //   // }
        //   formatter:
        //     '<span style="font-size:20px;margin-left: 8px; float: right;">{a} <br/>{b} : {c}（天）</span>',
        // },
        tooltip: {
     axisPointer: {
              type: "line", // 指示器类型（'line' 直线指示器；'shadow' 阴影指示器；'none' 无指示器；'cross' 十字准星指示器。）
              snap: false, // 坐标轴指示器是否自动吸附到点上。默认自动判断。
            },
            showContent: true, // 是否显示提示框浮层，默认显示
            alwaysShowContent: true, // 是否永远显示提示框内容，默认情况下在移出可触发提示框区域后一定时间后隐藏
            triggerOn: "mousemove", // 提示框触发的条件（'mousemove'，鼠标移动时触发；'click'，鼠标点击时触发；'mousemove|click'，同时鼠标移动和点击时触发；'none'，不在 'mousemove' 或 'click' 时触发）
            confine: true, // 是否将 tooltip 框限制在图表的区域内
            backgroundColor: "rgba(0,0,0,0)", // 提示框浮层的背景颜色
            padding: 15, // 提示框浮层内边距，单位px
            position: "left",
            textStyle: {
              color: "#78EC4E", // 文字的颜色
              fontStyle: "normal", // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
              fontWeight: "normal", // 文字字体的粗细（'normal'，无样式；'bold'，加粗；'bolder'，加粗的基础上再加粗；'lighter'，变细；数字定义粗细也可以，取值范围100至700）
            },
  },
        grid: {
          top: "23%",
          fontSize: 18,
        },
        color: ["#FFCE51", "#82F2F4"],
        xAxis: {
          // type: "category",
          boundaryGap: true,
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 0, //使x轴文字显示全
          },
          data: ["一级工单", "二级工单", "三级工单", "四级工单"],
        },
        title: {
          text: "单位:天",
        },
        yAxis: {
          type: "value",
          nameTextStyle: {
            fontSize: 26,
          },
        },
        series: [
          {
            name: "响应天数",
            type: "bar",
            smooth: true,
            data: [90.2, 60.1, 29.35, 14.5],
            barWidth: 15,
            // tooltip: {
            //   valueFormatter: function (value) {
            //     return value + "天";
            //   },
            // },
            itemStyle: {
              barBorderRadius: [2, 2, 0, 0], //柱体圆角
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  //代表渐变色从正上方开始
                  offset: 0, //offset范围是0~1，用于表示位置，0是指0%处的颜色
                  color: "rgba(26, 239, 239, 1)",
                }, //柱图渐变色
                {
                  offset: 1, //指100%处的颜色
                  color: "rgba(26, 239, 239, 0)",
                },
              ]),
            },
            lineStyle: {
              color: "#1AEFEF",
            },
            // areaStyle: {
            //   opacity: 0.8,
            //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //     {
            //       offset: 0,
            //       color: "#1AEFEF",
            //     },
            //     {
            //       offset: 1,
            //       color: "#2E4039",
            //     },
            //   ]),
            // },
          },
        ],
      },
      query: this.$route.query,
    };
  },
  mounted() {
    this.$bus.$on("onfangdiangonglv", () => {
      this.getBattery24hours();
    });
    this.getBattery24hours();
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      let cityCode = this.query.province || this.query.city || "000000";
      let params = {
        enCode: "zngf-qg-j24xsgsdfdxl", // 接口code
        // 接口传参
        "@adcode": cityCode,
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "发电效率与收益排行榜");
          if (res) {
            let data = [];
            let data2 = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(item.cur_hour); // 小时
              data.push(item.generate_electricity); // 发电效率
            });
            // this.cdata.xAxis.data = xAxis;
            // this.cdata.series[0].data = data;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
